import { Modal, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import GlobalSpinner from '../../../Components2/common/GlobalSpinner';
import AddEditUserForm from './AddEditUserForm';
import useGetUserByAuth0Id from './useGetUserByAuth0Id';
import useUpdateUser from './useEditUser';
const OPEN = true;

const validationSchema = yup.object().shape({
  name: yup.string().required('El nombre es obligatorio'),
  email: yup
    .string()
    .required('El email es obligatorio')
    .transform((value) => value.toLowerCase().trim())
    .email('El email es invalido'),
  centers: yup.array().min(1, 'Debes seleccionar al menos un centro').required('Debes seleccionar al menos un centro'),
});

const EditUser = () => {
  const navigate = useNavigate();
  const { data, isLoading, isError } = useGetUserByAuth0Id();
  const { mutateAsync, isLoading: isPending } = useUpdateUser();
  const handleOnClose = () => {
    navigate('../');
  };

  return (
    <Modal open={OPEN} onClose={handleOnClose}>
      <div className="create-center-container-modal">
        {!isLoading && !isError ? (
          <div className="center-form-title">
            <Typography
              variant="h4"
              component="h2"
              align="center"
              sx={{ fontWeight: 'bold', marginBottom: '1.5rem', backgroundColor: '#3C4145', color: 'white' }}
            >
              EDITAR USUARIO
            </Typography>

            <AddEditUserForm
              validationSchema={validationSchema}
              initialValues={{
                email: data.email,
                name: data.name,
                centers: data.centers.map((c) => ({ _id: c.center._id, code: c.center.code, name: c.center.name })),
                roles: data.rolesWithName.map((r) => r.name),
              }}
              mutateAsync={mutateAsync}
              handleOnClose={handleOnClose}
              isPending={isPending}
            />
          </div>
        ) : !isError ? (
          <div className="spinner-container">
            <GlobalSpinner />
          </div>
        ) : (
          <div className="error-message-users">Algo ha ido mal al cargar este usuario...</div>
        )}
      </div>
    </Modal>
  );
};

export default EditUser;
